export default {
  methods: {
    getCurrentYear () {
      return (new Date()).getFullYear()
    }
  }

}
